/* tslint:disable */
/* eslint-disable */
/**
 * CheckFlow
 * CheckFlow
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddMissedReasonCommand
 */
export interface AddMissedReasonCommand {
    /**
     * 
     * @type {number}
     * @memberof AddMissedReasonCommand
     */
    checkResponseId?: number;
    /**
     * 
     * @type {number}
     * @memberof AddMissedReasonCommand
     */
    explanationId?: number;
}

/**
 * Check if a given object implements the AddMissedReasonCommand interface.
 */
export function instanceOfAddMissedReasonCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AddMissedReasonCommandFromJSON(json: any): AddMissedReasonCommand {
    return AddMissedReasonCommandFromJSONTyped(json, false);
}

export function AddMissedReasonCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddMissedReasonCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checkResponseId': !exists(json, 'checkResponseId') ? undefined : json['checkResponseId'],
        'explanationId': !exists(json, 'explanationId') ? undefined : json['explanationId'],
    };
}

export function AddMissedReasonCommandToJSON(value?: AddMissedReasonCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checkResponseId': value.checkResponseId,
        'explanationId': value.explanationId,
    };
}

